<template>
    <div class="page-wrap">
        <div class="page-bar">
            <div>
                <div class="page-bar-sub">Team</div>
                <div class="page-bar-main">Announcements</div>
            </div>
        </div>
        <div :class="$store.state.routeLoaded ? 'slide-up view' : 'hide'">
            <div v-if="$store.state.user.isAdmin" class="page-filters pf-bar">
                <select v-model="selectedLocation" @change="getAnnouncements()">
                    <option v-for="(location, i) in $store.state.user.locations" :key="i" :value="location">{{ location }}</option>
                </select>
                <span class="pf-spacer"></span>
                <forge-page-button :kinds="['announcement']" label="Write with AI" @applied="getAnnouncements()" />
                <div v-if="$store.state.user.teamHubRole == 'Admin'" @click="addAnnouncement()" class="add-btn">Add</div>
            </div>
            <div v-else style="height:15px"></div>
            <div class="announcements">
                <div v-for="(an, i) in announcements" :key="i">
                    <div><i>{{ an.DateDisplay }}</i></div>
                    <div v-html="an.TextDisplay"></div>
                    <div><b>&nbsp;&nbsp;- {{ an.CreatedBy }}</b></div>
                    <div v-if="$store.state.user.teamHubRole == 'Admin'" style="text-align:right"><a @click.prevent="deleteAnnouncement(an)" style="color:red;text-decoration:underline">Delete</a></div>
                </div>
            </div>
        </div>

        <div v-if="showAdd" class="error-msg-wrap">
            <div class="form-wrapper slide-up">
                <div class="form-close">
                    <button type="button" class="form-close-x" title="Close" @click="() => { showAdd = false }">&times;</button>
                </div>
                <div>
                    <h3>Location</h3>
                    <select v-model="formData.Location">
                        <option v-for="(location, i) in $store.state.user.locations" :key="i" :value="location">{{ location }}</option>
                    </select>
                </div>
                <div>
                    <h3>Message</h3>
                    <textarea v-model="formData.Text" />
                </div>
                <input :class="disableButton ? 'disable-button' : ''" type="submit" value="Submit" @click="submit()" />
            </div>
        </div>

        <confirm-delete v-if="showConfirmDelete" @confirm="deleteAnnounementConfirm" @cancel="() => { showConfirmDelete = false; }" msg="Are you sure you would like to delete this announcement?"/>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import ConfirmDelete from '@/components/ConfirmDelete.vue';
import ForgePageButton from '@/components/ForgePageButton.vue';

export default defineComponent({
    name: 'AnnouncementsView',
    components: {
        ConfirmDelete,
        ForgePageButton
    },
    data() {
        return {
            announcements: [] as any,
            formData: {
                Text: '',
                Location: ''
            },
            selectedLocation: '',
            showAdd: false,
            disableButton: false,
            idToDelete: null as any,
            showConfirmDelete: false
        }
    },
    async created() {
        if(this.$store.state.user.isAdmin) {
            this.formData.Location = this.$store.state.user.locations[0];
            this.selectedLocation = this.$store.state.user.locations[0];
        } else {
            this.selectedLocation = this.$store.state.user.naLocation;
        }
        
        await this.getAnnouncements();

        this.$store.state.routeLoaded = true;
    },
    methods: {
        async getAnnouncements() {
            // Encoded: location names can contain & or # (e.g. "Shop & Office"), which would cut the query short
            await axios.get(`${this.$store.state.apiUrl}/api/announcements?location=${encodeURIComponent(this.selectedLocation)}`,)
                .then(resp => {
                    for(const an of resp.data) {
                        an.DateDisplay = new Date(an.Date).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' });
                        an.TextDisplay = an.Text.replace(/\n/g, '<br/>');
                    }
                    this.announcements = resp.data;
                })
                .catch(e => {
                    console.log(e);
                })
        },
        addAnnouncement() {
            this.formData.Text = '';
            this.showAdd = true;
        },
        async submit() {
            if(!this.formData.Text || !this.formData.Location) {
                alert('Include message and location');
                return;
            }
            this.disableButton = true;

            await axios.post(`${this.$store.state.apiUrl}/api/announcements`, this.formData)
                .then(resp => {
                    alert('Announcement has been added and text message sent!');
                    this.getAnnouncements();
                    this.showAdd = false;
                })
                .catch(e => {
                    alert('There was an error');
                })

            this.disableButton = false;
        },
        deleteAnnouncement(an: any) {
            this.idToDelete = an.ID;
            this.showConfirmDelete = true;
        },
        deleteAnnounementConfirm() {
            axios.delete(`${this.$store.state.apiUrl}/api/announcements/${this.idToDelete}`)
                .then(resp => {
                    this.getAnnouncements();
                    this.showConfirmDelete = false;
                })
                .catch(e => {
                    alert('There was an error');
                })
        }
    }
});
</script>
